import { apiSlice } from './apiSlice';
const STOREEXPENSES_URL = '/api/storeExpenses';

export const storeExpensesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStoreExpenses: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: STOREEXPENSES_URL,
        params: { keyword, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['StoreExpenses'],
    }),
    getStoreExpenseDetails: builder.query({
      query: (storeExpenseId) => ({
        url: `${STOREEXPENSES_URL}/${storeExpenseId}`,
      }),
      keepUnusedDataFor: 5,
    }),
    createStoreExpense: builder.mutation({
      query: (storeExpenseData) => ({
        url: STOREEXPENSES_URL,
        method: 'POST',
        body: storeExpenseData,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['StoreExpenses'],
    }),
    updateStoreExpense: builder.mutation({
      query: ({ storeExpenseId, ...data }) => ({
        url: `${STOREEXPENSES_URL}/${storeExpenseId}`,
        method: 'PUT',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['StoreExpenses'],
    }),
    uploadStoreExpenseImages: builder.mutation({
      query: (formData) => ({
        url: '/api/upload',
        method: 'POST',
        body: formData,
      }),
    }),
    bulkUpdateStoreExpenses: builder.mutation({
  query: (storeExpenseData) => ({
    url: `${STOREEXPENSES_URL}/bulk`, // Adjust this if your backend uses a different route
    method: 'PUT',
    body: storeExpenseData,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
  invalidatesTags: ['StoreExpenses'],
}),
    deleteStoreExpense: builder.mutation({
      query: (storeExpenseId) => ({
        url: `${STOREEXPENSES_URL}/${storeExpenseId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['StoreExpenses'],
    }),
    createReview: builder.mutation({
      query: ({ storeExpenseId, ...data }) => ({
        url: `${STOREEXPENSES_URL}/${storeExpenseId}/reviews`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['StoreExpenses'],
    }),
    getTopStoreExpenses: builder.query({
      query: () => `${STOREEXPENSES_URL}/top`,
      keepUnusedDataFor: 5,
    }),
  }),
});


export const {
  useGetStoreExpensesQuery,
  useGetStoreExpenseDetailsQuery,
  useCreateStoreExpenseMutation,
  useUpdateStoreExpenseMutation,
  useUploadStoreExpenseImagesMutation,
  useDeleteStoreExpenseMutation,
  useCreateReviewMutation,
  useGetTopStoreExpensesQuery,
  useBulkUpdateStoreExpensesMutation,
} = storeExpensesApiSlice;